import React from "react";
import Layout from "../../routes/Layout";

const TermsConditions = () => {
  return (
    <Layout>
      <div className="lading-page bg-[#212020] min-h-screen flex flex-col w-full">
        <div className="wrap wrapWidth flex flex-col">
          <h1 className="sm:text-4xl text-2xl font-medium mb-6 text-center text-white">
            Terms and Conditions
          </h1>
          <div className="bg-white sm:p-8 p-3 rounded-lg shadow-lg">
            <section className="mb-6">
              <h2 className="text-2xl font-normal mb-4">
                Effective Date: [Date]
              </h2>
            </section>
            <section className="mb-6">
              <h2 className="text-2xl font-medium mb-4">Introduction</h2>
              <p className="text-gray-700">
                Welcome to SmartTract! These Terms and Conditions govern your
                use of the SmartTract mobile application (the "App"), operated
                by SmartTract LLC ("we," "our," or "us"). By accessing or using
                our App, you agree to comply with and be bound by these Terms
                and Conditions. If you do not agree to these terms, please do
                not use the App.
              </p>
            </section>
            <section className="mb-6">
              <h1 className="text-3xl font-medium my-4">Use of the App</h1>
              <h2 className="text-2xl font-medium mb-4">Eligibility</h2>
              <p className="text-gray-700">
                You must be at least 18 years old to use the App. By using the
                App, you represent and warrant that you meet this age
                requirement.
              </p>
            </section>
            <section className="mb-6">
              <h2 className="text-2xl font-medium mb-4">License</h2>
              <p className="text-gray-700">
                SmartTract LLC grants you a non-exclusive, non-transferable,
                revocable license to use the App for personal, non-commercial
                purposes, subject to these Terms and Conditions.
              </p>
            </section>
            <section className="mb-6">
              <h2 className="text-2xl font-medium mb-4">User Account</h2>
              <p className="text-gray-700">
                To access certain features of the App, you may be required to
                create an account. You agree to provide accurate, current, and
                complete information during the registration process and to
                update such information to keep it accurate, current, and
                complete. You are responsible for maintaining the
                confidentiality of your account password and for all activities
                that occur under your account.
              </p>
            </section>
            <section className="mb-6">
              <h2 className="text-2xl font-medium mb-4">User Conduct</h2>
              <p className="text-gray-700">
                You agree not to use the App for any unlawful or prohibited
                activities, including but not limited to:
              </p>
              <ul className="list-disc list-inside text-gray-700">
                <li className="mb-2">
                  Engaging in any illegal activities or conduct that violates
                  any applicable laws or regulations.
                </li>
                <li className="mb-2">
                  Uploading, posting, or transmitting any content that is
                  harmful, offensive, or inappropriate.
                </li>
                <li className="mb-2">
                  Attempting to gain unauthorized access to the App or its
                  related systems or networks
                </li>
                <li className="mb-2">
                  Interfering with or disrupting the App's operation or
                  security.
                </li>
              </ul>
            </section>
            <section className="mb-6">
              <h2 className="text-2xl font-medium mb-4">
                Intellectual Property
              </h2>
              <p className="text-gray-700">
                All content, features, and functionality of the App, including
                but not limited to text, graphics, logos, images, and software,
                are the exclusive property of SmartTract LLC and are protected
                by copyright, trademark, and other intellectual property laws.
                You may not reproduce, distribute, modify, or create derivative
                works based on any content provided through the App without our
                prior written consent.
              </p>
            </section>
            <section className="mb-6">
              <h2 className="text-2xl font-medium mb-4">Privacy</h2>
              <p className="text-gray-700">
                Your use of the App is also governed by our Privacy Policy,
                which is incorporated by reference into these Terms and
                Conditions. Please review our Privacy Policy to understand our
                practices regarding the collection, use, and disclosure of your
                personal information.
              </p>
            </section>
            <section className="mb-6">
              <h2 className="text-2xl font-medium mb-4">
                Disclaimer of Warranties
              </h2>
              <p className="text-gray-700">
                The App is provided on an "as is" and "as available" basis. We
                make no representations or warranties of any kind, express or
                implied, regarding the operation or availability of the App or
                the information, content, or materials included therein. To the
                fullest extent permitted by law, we disclaim all warranties,
                express or implied, including but not limited to implied
                warranties of merchantability and fitness for a particular
                purpose.
              </p>
            </section>
            <section className="mb-6">
              <h2 className="text-2xl font-medium mb-4">
                Limitation of Liability
              </h2>
              <p className="text-gray-700">
                To the fullest extent permitted by law, SmartTract LLC shall not
                be liable for any indirect, incidental, special, consequential,
                or punitive damages, including but not limited to damages for
                loss of profits, data, use, or other intangible losses,
                resulting from your use of or inability to use the App, even if
                we have been advised of the possibility of such damages.
              </p>
            </section>
            <section className="mb-6">
              <h2 className="text-2xl font-medium mb-4">Indemnification</h2>
              <p className="text-gray-700">
                You agree to indemnify, defend, and hold harmless SmartTract
                LLC, its officers, directors, employees, and agents, from and
                against any claims, liabilities, damages, losses, and expenses,
                including reasonable attorney's fees, arising out of or in any
                way connected with your use of the App, your violation of these
                Terms and Conditions, or your violation of any rights of
                another.
              </p>
            </section>
            <section className="mb-6">
              <h2 className="text-2xl font-medium mb-4">
                Modifications to the Terms and Conditions
              </h2>
              <p className="text-gray-700">
                We reserve the right to modify these Terms and Conditions at any
                time. We will notify you of any changes by posting the new Terms
                and Conditions on this page and updating the effective date.
                Your continued use of the App after any such changes constitutes
                your acceptance of the new Terms and Conditions.
              </p>
            </section>
            <section className="mb-6">
              <h2 className="text-2xl font-medium mb-4">Termination</h2>
              <p className="text-gray-700">
                We may terminate or suspend your access to the App, without
                prior notice or liability, for any reason, including if you
                breach these Terms and Conditions. Upon termination, your right
                to use the App will immediately cease.
              </p>
            </section>
            <section className="mb-6">
              <h2 className="text-2xl font-medium mb-4">Governing Law</h2>
              <p className="text-gray-700">
                These Terms and Conditions shall be governed by and construed in
                accordance with the laws of the State of [Your State], without
                regard to its conflict of law provisions. You agree to submit to
                the personal and exclusive jurisdiction of the courts located
                within [Your State] to resolve any dispute or claim arising from
                these Terms and Conditions or your use of the App.
              </p>
            </section>
            <section className="mb-6">
              <h2 className="text-2xl font-medium mb-4">Governing Law</h2>
              <p className="text-gray-700">
                These Terms and Conditions shall be governed by and construed in
                accordance with the laws of the State of [Your State], without
                regard to its conflict of law provisions. You agree to submit to
                the personal and exclusive jurisdiction of the courts located
                within [Your State] to resolve any dispute or claim arising from
                these Terms and Conditions or your use of the App.
              </p>
            </section>

            <section className="mb-6">
              <h2 className="text-2xl font-medium mb-4">Contact Us</h2>
              <p className="text-gray-700 my-4">
                If you have any questions about these Terms and Conditions,
                please contact us at:
              </p>
              <ul className="list-disc list-inside text-gray-700">
                <li className="mb-2">
                  <strong>Email:</strong> Privacy@smarttract.com
                </li>
                <li className="mb-2">
                  <strong>Address:</strong> [Your Address]
                </li>
              </ul>
              <p className="text-gray-700 my-4">
                By using SmartTract, you acknowledge that you have read and
                understood these Terms and Conditions and agree to be bound by
                them.
              </p>
            </section>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default TermsConditions;
